import Image from 'next/image';
import { getImageBasePath } from 'utils/generics';
import * as Styles from './styles';

interface IProps {
    index: number;
    name: string;
    phone: string;
    hasPermission: boolean;
    onClick: any;
}

function DealerDetails({ index, name, phone, hasPermission, onClick }: IProps) {
    return (
        <Styles.Wrapper>
            <Styles.DetailsFlex>
                <Styles.DealerDetailsFlex>
                    <Styles.Name>{name}</Styles.Name>
                    <Styles.Phone>{phone}</Styles.Phone>
                </Styles.DealerDetailsFlex>
                <Styles.DeleteIconFlex>
                    {hasPermission && (
                        <Image
                            width={'24px'}
                            height={'24px'}
                            alt={''}
                            src={getImageBasePath('/icons/trash.svg')}
                            onClick={() => onClick(index, name, phone)}
                        />
                    )}
                </Styles.DeleteIconFlex>
            </Styles.DetailsFlex>
            <Styles.Hr />
        </Styles.Wrapper>
    );
}

export default DealerDetails;
